









































import AbpBase from "@/lib/abpbase";
import { Component, Prop, Watch, Emit } from "vue-property-decorator";
import { GetListByCode} from "@/api/configureDictionary";
import { QueryEducationPlanList} from "@/api/pdEducationPlan/pdPatientEducationPlan";
@Component({})
export default class PdPatientEducationPlanAdd extends AbpBase {
  @Prop() patient: any;
  split1: number = 0.3;
  formData: any = {
    type: 1,
    keyCode: "",
    dirCode: "",
    classCode: ""
  };
  loading: boolean = false;
  columns = [
    {
      type: "selection",
      minWidth: 60,
      align: "center"
    },
    {
      title: "计划名称",
      minWidth: 200,
      key: "title"
    },
    {
      title: "计划说明",
      minWidth: 500,
      key: "description"
    }
  ];
  data: any = [];
  selectedList: any = [];
  EducationPlanComponent: any = {};

  async getData() {
    this.loading = true;
    this.selectedList=[];
    this.EducationPlanComponent.SkipCount=1;
    this.EducationPlanComponent.MaxResultCount=10;
    var res = await QueryEducationPlanList(this.EducationPlanComponent);
    this.data = res.objects;
    this.loading = false;
  }

  handleSelect(selection: any, row: any) {
    this.selectedList.push(row);
  }

  handleSelectCancel(selection: any, row: any) {
    this.selectedList.splice(
      this.selectedList.findIndex((x: any) => x.id == row.id),
      1
    );
  }

  handleSelectAll() {
    this.data.forEach((item: any) => {
      if (this.selectedList.findIndex((x: any) => x.id == item.id) == -1) {
        this.selectedList.push(item);
      }
    });
  }

  handleSelectAllCancel() {
    this.data.forEach((item: any) => {
      this.selectedList.splice(
        this.selectedList.findIndex((x: any) => x.id == item.id),
        1
      );
    });
  }
  created(){
    this.getData() 
  }
  initDic() {
  }
  onSubmit() {
    return this.selectedList;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdOutPatient/pdEducation/pdPatientEducationPlan/pdPatientEducationPlanAdd.vue